<template>
  <div>
    <div class="content-i">
      <div class="content-box pb-0">
        <div class="element-wrapper pb-0">
          <h6 class="element-header">
            {{t(title, title)}}
          </h6>
          <div class="element-box">
            <div class="element-info my-0">
              <div class="row align-items-center">
                <div class="col-sm-8">
                  <div class="element-info-with-icon">
                    <div class="element-info-icon">
                      <div class="os-icon os-icon-search2">
                      </div>
                    </div>
                    <div class="element-info-text">
                      <h5 class="element-inner-header">
                        {{t(title, title)}}
                      </h5>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-3 col-md-4">
                  <i id="textToggle" v-b-toggle.search class="text-primary os-icon os-icon-arrow-up float-right showhand"></i>
                </div>
              </div>
            </div>
            <b-collapse id="search" ref="searchForm" v-model="visibleSearchBox">
              <form v-on:submit.prevent="loadInvoicingView">
                <div class="row">
                  <div class="col-lg-2 pt-3">
                    <div class="col-lg-12">
                      <div class="form-group">
                        <label for="batch-reference" class="d-block text-center"> {{t('searchLabelBatchRef', 'searchLabelBatchRef')}} </label>
                        <b-input id="batch-reference" v-model="invoicingBatchesRequest.batch_reference" class="form-control text-center" :placeholder="t('searchLabelBatchRef', 'searchLabelBatchRef')"></b-input>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <div class="form-group">
                        <label for="invoice-number" class="d-block text-center"> {{t('searchLabelInvoiceNo', 'searchLabelInvoiceNo')}} </label>
                        <b-input id="invoice-number" v-model="invoicingBatchesRequest.invoice_number" class="form-control text-center" :placeholder="t('searchLabelInvoiceNo', 'searchLabelInvoiceNo')"></b-input>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 pt-3">
                    <div class="col-lg-12">
                      <div class="form-group">
                        <label for="date-from" class="d-block text-center"> {{t('searchLabelBatchDAfter', 'searchLabelBatchDAfter')}} </label>
                        <datePicker id="date-from" v-model="invoicingBatchesRequest.date_from" class="form-control text-center" :config="datePickerFromConfig" :placeholder="t('searchLabelBatchDAfter', 'searchLabelBatchDAfter')"></datePicker>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <div class="form-group">
                        <label for="date-to" class="d-block text-center"> {{t('searchLabelBatchDBefore', 'searchLabelBatchDBefore')}} </label>
                        <datePicker id="date-to" v-model="invoicingBatchesRequest.date_to" class="form-control text-center" :config="datePickerToConfig" :placeholder="t('searchLabelBatchDBefore', 'searchLabelBatchDBefore')"></datePicker>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 pt-3">
                    <div class="col-lg-12">
                      <div class="form-group">
                        <label for="batch-type" class="d-block text-center">{{ t('searchLabelBatchType','searchLabelBatchType') }}</label>
                        <b-form-select id="batch-type" v-model="invoicingBatchesRequest.batch_type" multiple :select-size="6" class="form-control custom-select text-capitalize">
                          <b-form-select-option v-for="batch in batchTypes" :key="batch.id" :value="batch.id">{{batch.name}}</b-form-select-option>
                        </b-form-select>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 pt-3" v-if="principles && principles.length">
                    <div class="col-lg-12">
                      <div class="form-group">
                        <label for="principles" class="d-block text-center">{{ t('searchLabelPrinciples','searchLabelPrinciples') }}</label>
                        <b-form-select id="batch-status" v-model="invoicingBatchesRequest.principles" multiple :select-size="6" class="form-control custom-select text-capitalize">
                          <b-form-select-option v-for="principle in principles" :key="principle.id" :value="principle.id">{{principle.name}}</b-form-select-option>
                        </b-form-select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row justify-content-between pt-3">
                  <div class="col-lg-2">
                    <b-input-group class="col-lg-12">
                      <b-input-group-prepend>
                        <label class="input-group-text"> {{ t('paginationPerPage','paginationPerPage') }} </label>
                      </b-input-group-prepend>
                      <b-form-select v-model="perPage" :options="pageOptions" @change="loadInvoicingView"></b-form-select>
                    </b-input-group>
                  </div>
                  <div class="col-lg-4 text-right mt-3">
                    <button v-if="!loading" class="btn btn-primary" type="submit" > {{ t('searchButtonText', 'searchButtonText') }} </button>
                    <b-button v-else variant="primary" disabled>
                      <b-spinner small type="grow"></b-spinner>
                      {{t('searchButtonText', 'searchButtonText')}}
                    </b-button>
                  </div>
                </div>
              </form>
            </b-collapse>
          </div>
        </div>
        <div class="element-wrapper mt-0 pb-0 pt-0">
          <ResponseInfo class="px-0 py-0" v-if="getResponseInfo.responseName === 'invoicingBatchesView'" />
        </div>
      </div>
    </div>
    <div class="content-i" v-if="items">
      <div class="content-box pt-0">
        <div class="element-wrapper">
          <div class="element-box">
            <div class="element-box-tp">
              <div class="controls-below-table row">
                <div class="col-12 mb-2" v-if="warnings.length">
                  <b-alert show variant="warning">
                    <span v-for="warning in warnings" :key="warning"> {{t(warning, warning)}}</span>
                  </b-alert>
                </div>
                <div class="col-sm-12 col-lg-4 col-md-12 table-records-info">
                  <p> {{totalRows}} {{ t('invoicingBatchesListEntriesFound','invoicingBatchesListEntriesFound') }} </p>
                </div>
                <div class="col-sm-12 col-lg-6 col-md-8">
                  <b-pagination class="float-right mb-0" v-model="currentPage" :total-rows="totalRows" :per-page="perPage" aria-controls="invoicing-report-table">
                  </b-pagination>
                </div>
                <div class="col-sm-12 col-lg-2 col-md-4">
                  <b-input-group class="form-group col-lg-12">
                    <b-input-group-prepend>
                      <label class="input-group-text"> {{ t('paginationPerPage','paginationPerPage') }} </label>
                    </b-input-group-prepend>
                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                  </b-input-group>
                </div>
              </div>
              <b-table id="invoicing-report-table" class="mt-3" responsive striped hover bordered :fields="fields" :busy.sync="loading" :items="items" :currentPage="currentPage" :total-rows="totalRows" :show-empty="true" foot-clone :tbody-tr-class="rowClass" :thead-class="'brand-color'" :tfoot-class="'footer-summary'">
                <template class="busy-row" slot="table-busy" slot-scope="items" v-bind:value="items">
                  <vcl-table :rows="5" :columns="fields.length"></vcl-table>
                </template>
                <template v-slot:head(checkbox)="data">
                  <template v-if="!allSelected">
                    <fontAwesomeIcon @click="checkAllInvoices()" :icon="['far', 'square']" class="showhand" size="2x"/>
                  </template>
                  <template v-else>
                    <fontAwesomeIcon @click="unCheckAllInvoices()" :icon="['far', 'check-square']" class="showhand" size="2x"/>
                  </template>
                </template>
                <template v-slot:head(batch_id)="data">
                  <span >{{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(invoice_no)="data">
                  <span >{{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(type_name)="data">
                  <span >{{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(total_docs)="data">
                  <span >{{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(deleted_docs)="data">
                  <span >{{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(dataxferred_docs)="data">
                  <span >{{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(total_emailed)="data">
                  <span >{{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(total_faxed)="data">
                  <span >{{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(total_posted)="data">
                  <span >{{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:head(online_docs)="data">
                  <span >{{ t(data.label, data.label) }}</span>
                </template>
                <template v-slot:cell(checkbox)="data">
                  <b-form-group class="my-0">
                    <b-form-checkbox-group v-model="selectedInvoicingBatches" name="invoices" class="d-flex justify-content-center">
                      <b-form-checkbox class="my-0 pl-0" :value="data.item.id"></b-form-checkbox>
                    </b-form-checkbox-group>
                  </b-form-group>
                </template>
                <template v-slot:cell(batch_id)="data">
                  <router-link :to="{ name: 'documents_search', query: { page: 1, per_page: 20, batch: data.item.batch_id }}" :title="batchRefTitle(data.item)" target="_blank">
                    {{ data.item.reference ? data.item.reference : t('unknownTitle', 'unknownTitle') }}
                  </router-link>
                </template>
                <template v-slot:cell(type_name)="data">
                  <span v-if="data.item.type_name"> {{ data.item.type_name }}</span>
                  <span v-else> {{ t('unknownTitle', 'unknownTitle') }}</span>
                </template>
                <template v-slot:cell(total_docs)="data">
                  <span>{{data.item.total_docs}} ({{data.item.total_pages}})</span>
                </template>
                <template v-slot:cell(deleted_docs)="data">
                  <span>{{data.item.deleted_docs}} ({{data.item.deleted_pages}})</span>
                </template>
                <template v-slot:cell(dataxferred_docs)="data">
                  <span>{{data.item.dataxferred_docs}} ({{data.item.dataxferred_pages}})</span>
                </template>
                <template v-slot:cell(total_emailed)="data">
                  <span>{{data.item.total_emailed}} ({{data.item.pages_emailed}})</span>
                </template>
                <template v-slot:cell(total_faxed)="data">
                  <span>{{data.item.total_faxed}} ({{data.item.pages_faxed}})</span>
                </template>
                <template v-slot:cell(total_posted)="data">
                  <span>{{data.item.total_posted}} ({{data.item.pages_posted}})</span>
                </template>
                <template v-slot:cell(online_docs)="data">
                  <span>{{data.item.online_docs}} ({{data.item.online_pages}})</span>
                </template>

                <template v-slot:cell(actions)="data">
                  <div class="btn btn-sm btn-primary" @click="openUpdateModal(data.item, $event.target)"> {{t('updateButtonText', 'updateButtonText')}} </div>
                  <div class="btn btn-sm btn-danger" @click="openDeleteModal(data.item.id, $event.target)"> {{t('deleteButtonText', 'deleteButtonText')}} </div>
                </template>

                <template v-slot:foot(checkbox)="data">
                  <span> </span>
                </template>
                <template v-slot:foot(batch_id)="data">
                  <span> </span>
                </template>
                <template v-slot:foot(invoice_no)="data">
                  <span> </span>
                </template>
                <template v-slot:foot(type_name)="data">
                  <span> </span>
                </template>
                <template v-slot:foot(total_docs)="data">
                  <span> {{ calculations['total_doc_num'] }} ({{ calculations['total_page_num']}}) </span>
                </template>
                <template v-slot:foot(deleted_docs)="data">
                  <span> {{ calculations['deleted_docs_num']}} ({{ calculations['deleted_pages_num']}}) </span>
                </template>
                <template v-slot:foot(dataxferred_docs)="data">
                  <span> {{ calculations['dataxferred_docs_num']}} ({{ calculations['dataxferred_pages_num']}}) </span>
                </template>
                <template v-slot:foot(total_emailed)="data">
                  <span> {{ calculations['total_emailed_num'] }} ({{ calculations['pages_emailed_num']}}) </span>
                </template>
                <template v-slot:foot(total_faxed)="data">
                  <span> {{ calculations['total_faxed_num'] }} ({{ calculations['pages_faxed_num']}}) </span>
                </template>
                <template v-slot:foot(total_posted)="data">
                  <span> {{ calculations['total_posted_num']}} ({{ calculations['pages_posted_num'] }}) </span>
                </template>
                <template v-slot:foot(online_docs)="data">
                  <span> {{ calculations['online_docs_num']}} ({{ calculations['online_pages_num']}})</span>
                </template>
              </b-table>
              <div class="controls-below-table mt-4 row">
                <div class="col-sm-12 col-lg-4 col-md-12 table-records-info">
                  <p> {{totalRows}} {{ t('invoicingBatchesListEntriesFound', 'invoicingBatchesListEntriesFound') }} </p>
                </div>
                <div class="col-sm-12 col-lg-6 col-md-8">
                  <b-pagination class="float-right mb-0" v-model="currentPage" :total-rows="totalRows" :per-page="perPage" aria-controls="invoicing-report-table">
                  </b-pagination>
                </div>
                <div class="col-sm-12 col-lg-2 col-md-4">
                  <b-input-group class="form-group col-lg-12">
                    <b-input-group-prepend>
                      <label class="input-group-text"> {{ t('paginationPerPage','paginationPerPage') }} </label>
                    </b-input-group-prepend>
                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                  </b-input-group>
                </div>
              </div>
              <div class="col-12 text-left px-0">
                <fieldset>
                  <ul class="list-unstyled px-0">
                    <li>
                      <span class="px-1">{{t('tipBatchWithRedBackground', 'tipBatchWithRedBackground')}}</span>
                    </li>
                    <li>
                      <span class="px-1">{{t('tipBatchWithYellowBackground', 'tipBatchWithYellowBackground')}}</span>
                    </li>
                    <li>
                      <span class="px-1">{{t('tipBatchWithOrangeBackground', 'tipBatchWithOrangeBackground')}}</span>
                    </li>
                    <li>
                      <span class="px-1">{{t('tipBatchWithRAndRedBackground', 'tipBatchWithRAndRedBackground')}}</span>
                    </li>
                    <li>
                      <span class="px-1">{{t('tipBatchWithMAndGreyBackground', 'tipBatchWithMAndGreyBackground')}}</span>
                    </li>
                  </ul>
                </fieldset>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalDeleteItem :modal="deleteModal" @hide="resetDeleteModal" @deleteItem="deleteInvoicingBatch"/>
    <ModalUpdateInvoicingBatchItem :modal="updateModal" @hide="resetUpdateModal" @updateItem="updateInvoicingBatch"/>
    <div v-if="overlayBackgroundDisplay" class="modal-backdrop show"></div>
  </div>
</template>

<script>
import {VclTable} from 'vue-content-loading'
import ResponseInfo from '@/components/ResponseInfo.vue'
import {mapGetters} from "vuex"
import moment from "moment"
import datePicker from 'vue-bootstrap-datetimepicker'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import ModalDeleteItem from "@/components/Helper_Components/ModalDeleteItem.vue";
import ModalUpdateInvoicingBatchItem from "@/components/Invoicing/ModalUpdateInvoicingBatchItem.vue"

export default {
  name: 'InvoicingView',
  components: {
    VclTable,
    ResponseInfo,
    datePicker,
    ModalDeleteItem,
    ModalUpdateInvoicingBatchItem
  },
  props:['title', 'status'],
  data() {
    return {
      deleteModal: {
        itemId: null,
        title: 'titleDeleteInvoicingBatchModal',
        id: 'deleteInvoicingBatchModal',
        question: 'questionDeleteInvoicingBatchModal'
      },
      updateModal: {
        invoiceItem: null,
        title: 'titleUpdateInvoicingBatchModal',
        id: 'updateInvoicingBatchModal',
      },
      selectedInvoicingBatches: [],
      invoicingBatchesRequest: {
        batch_reference: this.$route.query.batch_reference,
        date_from: this.$route.query.date_from,
        date_to: this.$route.query.date_to,
        batch_type: this.$route.query.batch_type ? this.$route.query.batch_type : [],
        invoice_number: this.$route.query.invoice_number,
        principles: this.$route.query.principles ? this.$route.query.principles : [],
      },
      visibleSearchBox: true,
      datePickerFromConfig: {
        icons: {
          time: 'os-icon os-icon-calendar-time',
          date: 'os-icon os-icon-basic-2-259-calendar',
          up: 'os-icon os-icon-chevron-up',
          down: 'os-icon os-icon-chevron-down',
          previous: 'os-icon os-icon-chevron-left',
          next: 'os-icon os-icon-chevron-right',
          clear: 'os-icon os-icon-trash',
          close: 'os-icon os-icon-cancel-circle'
        },
        showClear: true
      },
      datePickerToConfig: {
        icons: {
          time: 'os-icon os-icon-calendar-time',
          date: 'os-icon os-icon-basic-2-259-calendar',
          up: 'os-icon os-icon-chevron-up',
          down: 'os-icon os-icon-chevron-down',
          previous: 'os-icon os-icon-chevron-left',
          next: 'os-icon os-icon-chevron-right',
          clear: 'os-icon os-icon-trash',
          close: 'os-icon os-icon-cancel-circle'
        },
        minDate: moment(new Date('1979-01-01'), this.datePickerFormat),
        showClear: true
      },
      fields: [
        {key: 'checkbox', label: 'checkbox', sortable: false, thClass: 'hover-pointer'},
        {key: 'batch_id', label: 'tableHeadBatchReference', sortable: true, thClass: 'hover-pointer'},
        {key: 'invoice_no', label: 'tableHeadInvoiceNo', sortable: true, thClass: 'hover-pointer'},
        {key: 'type_name', label: 'tableHeadBatchType', sortable: true, thClass: 'hover-pointer'},
        {key: 'total_docs', label: 'tableHeadTotalDocs', sortable: true, thClass: 'hover-pointer'},
        {key: 'deleted_docs', label: 'tableHeadDeletedDocs', sortable: true, thClass: 'hover-pointer'},
        {key: 'dataxferred_docs', label: 'tableHeadDataxferredDocs', sortable: true, thClass: 'hover-pointer'},
        {key: 'total_emailed', label: 'tableHeadTotalMailed', sortable: true, thClass: 'hover-pointer'},
        {key: 'total_faxed', label: 'tableHeadTotalFaxed', sortable: true, thClass: 'hover-pointer'},
        {key: 'total_posted', label: 'tableHeadTotalPosted', sortable: true, thClass: 'hover-pointer'},
        {key: 'online_docs', label: 'tableHeadOnlineDocs', sortable: true, thClass: 'hover-pointer'},
        {key: 'actions', label: '', sortable: false},
      ],
      currentPage: this.$route.query.page ? this.$route.query.page : 1,
      perPage: this.$route.query.per_page ? this.$route.query.per_page : 20,
      pageOptions: [2, 10, 20, 50, 100],
      loading: false,
      overlayBackgroundDisplay: false,
    }
  },
  watch: {
    dateFrom(date) {
      if (date) {
        this.datePickerToConfig.minDate = moment(date, this.datePickerFormat)
      } else {
        this.datePickerToConfig.minDate = moment(new Date('1979-01-01'), this.datePickerFormat)
      }
    },
    perPage(newCount, oldCount) {
      if (newCount != oldCount) {
        this.loadInvoicingView()
      }
    },
    currentPage(newCount, oldCount) {
      if (newCount != oldCount) {
        this.loadInvoicingView()
      }
    },
  },
  methods: {
    openDeleteModal(invoiceId, button) {
      this.deleteModal.itemId = invoiceId
      this.overlayBackgroundDisplay = true
      this.$root.$emit('bv::show::modal', this.deleteModal.id, button)
    },
    resetDeleteModal() {
      this.$root.$emit('bv::hide::modal', this.deleteModal.id)
      this.overlayBackgroundDisplay = false
      this.deleteModal.itemId = null
    },
    deleteInvoicingBatch(done) {
      this.$store.dispatch('deleteInvoicingBatch', {
        itemId: this.deleteModal.itemId,
      }).then(() => {
        let responseStatus = this.getResponseInfo.status
        if (responseStatus !== 'error' && responseStatus !== 'warning') {
          this.loadInvoicingView()
        }
        this.resetDeleteModal()
      }).finally(() => {
        done();
      })
    },
    openUpdateModal(invoice, button) {
      this.updateModal.invoiceItem = Object.assign({}, invoice)
      this.overlayBackgroundDisplay = true
      this.$root.$emit('bv::show::modal', this.updateModal.id, button)
    },
    resetUpdateModal() {
      this.$root.$emit('bv::hide::modal', this.updateModal.id)
      this.overlayBackgroundDisplay = false
      this.updateModal.invoiceItem = null
    },
    updateInvoicingBatch(done) {
      this.$store.dispatch('updateInvoicingBatch', {
        item: this.updateModal.invoiceItem,
      }).then(() => {
        let responseStatus = this.getResponseInfo.status
        if (responseStatus !== 'error' && responseStatus !== 'warning') {
          this.resetUpdateModal()
          this.loadInvoicingView()
        }
      }).finally(() => {
        done();
      })
    },
    batchRefTitle(item) {
      if (item !== null && item !== undefined) {
        let date = this.formatDate(item.added_on, this.datePickerFormat)
        let text =  this.t('batchNoTitle', 'batchNoTitle')

        return text + ' ' + item.batch_id + ' - ' + date
      }

      return ''
    },
    formatDate(date, datePickerFormat) {
      return moment(date).format(datePickerFormat)
    },
    rowClass(item) {
      if (item !== null && item !== undefined) {
        if (item.incomplete && item.total_docs !== item.real_total_doc) {
          return 'table-orange'
        }
        else if(item.incomplete) {
          return 'table-warning'
        }
        else if(item.total_docs !== item.real_total_doc || item.total_pages !== item.real_total_page) {
          return 'table-danger'
        }
      }
    },
    loadBatchTypesAndPrincipalsForInvoicing() {
      this.$store.dispatch('loadBatchTypesAndPrincipalsForInvoicing')
    },
    checkAllInvoices() {
      let allInvoicesIds = []
      Object.keys(this.items).forEach((key) => (allInvoicesIds.push(this.items[key].id)))

      this.selectedInvoicingBatches = allInvoicesIds
    },
    unCheckAllInvoices() {
      this.selectedInvoicingBatches = []
    },
    loadInvoicingView() {
      this.loading = true

      Object.keys(this.invoicingBatchesRequest).forEach((key) => (this.invoicingBatchesRequest[key] === '' || this.invoicingBatchesRequest[key] === null) && (this.invoicingBatchesRequest[key] = undefined))
      this.$router.push({ query: { ...this.$route.query, ...this.invoicingBatchesRequest, page: this.currentPage, per_page: this.perPage } })

      this.$store.dispatch('loadInvoicingView', {
        batch_reference: this.invoicingBatchesRequest.batch_reference,
        invoice_number: this.invoicingBatchesRequest.invoice_number,
        date_from: this.invoicingBatchesRequest.date_from,
        date_to: this.invoicingBatchesRequest.date_to,
        batch_type: this.invoicingBatchesRequest.batch_type,
        principles: this.invoicingBatchesRequest.principles,
        page: this.currentPage,
        per_page: this.perPage,
        status: this.status
      }).finally(() => {
        this.loading = false
        this.visibleSearchBox = false
      })
    },
  },
  computed: {
    ...mapGetters(['getResponseInfo']),
    dateFrom() {
      return this.invoicingBatchesRequest.date_from
    },
    allSelected: {
      get() {
        let selected = this.selectedInvoicingBatches
        if (this.items.length) {
          for (let i = 0; i < this.items.length; i++) {
            if (!selected.includes(this.items[i].id)) {
              return false
            }
          }
        }

        return true
      }
    },
    batchTypes: {
      get() {
        return this.$store.getters.getInvoicingBatchTypes
      }
    },
    principles: {
      get() {
        return this.$store.getters.getInvoicingClientPrinciples
      }
    },
    datePickerFormat() {
      if (this.$store.getters.allTemplateDetails && this.$store.getters.allTemplateDetails.datePickerFormat) {
        return this.$store.getters.allTemplateDetails.datePickerFormat.replace(/-/g, '/')
      } else {
        return 'DD-MM-YYYY'
      }
    },
    invoicingView: {
      get() {
        return this.$store.getters.getInvoicingView
      },
      set() {
        return this.$store.commit('setInvoicingView', [])
      }
    },
    items: {
      get() {
        if (this.invoicingView && this.invoicingView.data) {
          return this.invoicingView.data
        }

        return null
      }
    },
    calculations: {
      get() {
        if (this.invoicingView && this.invoicingView.calculations) {
          return this.invoicingView.calculations
        }

        return null
      }
    },
    totalRows: {
      get() {
        if (this.invoicingView && this.invoicingView.total) {
          return this.invoicingView.total
        }

        return 0
      }
    },
    warnings: {
      get() {
        let warnings = []
        if (this.calculations) {
          if (this.calculations['total_doc_num'] !== this.calculations['real_total_doc_num']) {
            warnings.push('totalNumDocumentsNotMatched')
          }

          if (this.calculations['total_page_num'] !== this.calculations['real_total_page_num']) {
            warnings.push('totalNumPagesNotMatched')
          }
        }

        return warnings
      }
    }
  },
  created() {
    this.loadBatchTypesAndPrincipalsForInvoicing()

    this.datePickerFromConfig.format = this.datePickerFormat
    this.datePickerToConfig.format = this.datePickerFormat
    this.$store.dispatch('alertClearResponse')

    if (Object.keys(this.$route.query).length) {

      if (this.$route.query.batch_type) {
        if (!Array.isArray(this.$route.query.batch_type)) {
          this.invoicingBatchesRequest.batch_type = Array.of(this.$route.query.batch_type)
        }
      } else {
        this.invoicingBatchesRequest.batch_type = []
      }

      if (this.$route.query.principles) {
        if (!Array.isArray(this.$route.query.principles)) {
          this.invoicingBatchesRequest.principles = Array.of(this.$route.query.principles)
        }
      } else {
        this.invoicingBatchesRequest.principles = []
      }

      if (this.$route.query.page) {
        this.currentPage = parseInt(this.$route.query.page)
      }
      if (this.$route.query.per_page) {
        this.perPage = parseInt(this.$route.query.per_page)
      }

      this.loadInvoicingView()
    }
  },
  beforeDestroy(){
    this.invoicingView = []
  },
}

</script>

<style scoped>

.table-responsive >>> tbody, .table-responsive >>> thead {
  text-align: center;
}

.table-responsive >>> .brand-color {
  background-color: #047bf8 !important;
  color: white !important;
}

.table-responsive >>> .hover-pointer:hover {
  cursor: pointer !important;
}

#textToggle{
  font-size: 1.2rem;
  font-weight: bold;
  display:inline-block;
  -moz-transition: all .5s linear;
  -webkit-transition: all .5s linear;
  transition: all .5s linear;
}

#textToggle.collapsed{
  -moz-transform:rotate(180deg);
  -webkit-transform:rotate(180deg);
  transform:rotate(180deg);
}

.table-responsive >>> .footer-summary {
  background-color: lightgrey !important;
  text-align: center;
}
.table-responsive >>> tfoot th {
  font-weight: bold !important;
  font-size: 10pt !important;
}

.table-responsive >>> .total-results {
  background-color: rgba(4, 123, 248, 0.1);
}

.table-responsive >>> .table-orange:hover {
  background-color: #f5d5ba;
}

.table-responsive >>> .table-orange {
  background-color: #f5dcc6;
}
</style>
